import { gql } from '@apollo/client';

export default gql`
  {
    billingDetails @client {
      firstName
      lastName
      addressLine1
      addressLine2
      addressLine3
      city
      postalCode
      countryCode
      email
      phoneCountryCode
      phoneNumber
    }
  }
`;
